module.exports = __webpack_public_path__ + "img/pattern.47ca460.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/pattern.png
// module id = ./assets/img/pattern.png
// module chunks = 13 19 28